import { useAttachmentUploadPreSignedUrlQuery } from '@/hooks/qna/qna.gql.impl';
import { preSignedUrlFetch } from '@/utils/fetcher';

export interface ImageFileParams {
  origin: File;
  thumbnail: File;
}

export interface preSignedUrlParams {
  fileExtension: string;
  imageFile: ImageFileParams;
}

const uploadImage = async (params: preSignedUrlParams) => {
  const {
    attachmentUploadPreSignedUrl: { originalPath, originalPreSignedUrl, thumbnailPath, thumbnailPreSignedUrl },
  } = await useAttachmentUploadPreSignedUrlQuery.fetcher({
    fileExtension: params.fileExtension,
  })();

  // 헤더에 토큰 제거 필요
  const { status: originStatus } = await preSignedUrlFetch().put(`${originalPreSignedUrl}`, params.imageFile.origin);
  // 헤더에 토큰 제거 필요
  const { status: thumbnailStatus } = await preSignedUrlFetch().put(
    `${thumbnailPreSignedUrl}`,
    params.imageFile.thumbnail,
  );
  return {
    success: originStatus === 200 && thumbnailStatus === 200,
    imagePath: { originalPath, thumbnailPath },
  };
};

const image = { uploadImage };

export default image;
